'use client';

import { FunctionComponent, Suspense } from 'react';

import { POSStoreBanner } from '@/react/components/endless-aisle/POSStoreBanner';
import { ExchangeBanner } from '@/react/components/exchanges/ExchangeBanner';
import { useReturnsFlowState } from '@/react/components/returns/useReturnsFlowState';
import type { MaybePromise, Nullable } from '@/type-utils';

import { DirectContent } from '@/react/components/content/core/DirectContent';
import { type Content } from '@/services/isomorphic/ContentService';
import { isNullish } from '@/utils/null-utils';
import { observer } from 'mobx-react-lite';
import ConfigurationService from '@/services/isomorphic/ConfigurationService';

export interface IHeaderBannersProps {
  /**
   * The content that represents the banner.
   */
  contentBanner: Nullable<MaybePromise<Content>>;
}

/**
 * Renders the possible header banners and manages their state.
 */
export const HeaderBanners: FunctionComponent<IHeaderBannersProps> = observer(
  ({ contentBanner = null }) => {
    const returnsFlowState = useReturnsFlowState();

    const exchangeBannerNode = returnsFlowState?.isExchangeModeActive && (
      <ExchangeBanner flowState={returnsFlowState} />
    );

    const menuConfig = ConfigurationService.getConfig('menu');
    const showUtilityLinks = menuConfig.getSetting(
      'mainMenu.showUtilityLinks'
    ).value;

    return (
      <>
        {!showUtilityLinks && !isNullish(contentBanner) && (
          <Suspense>
            <DirectContent content={contentBanner} />
          </Suspense>
        )}
        {exchangeBannerNode}
        <POSStoreBanner />
      </>
    );
  }
);
